export default __webpack_public_path__ + "static/media/trending-up.a4134be3.svg";